import Vue from "vue"
import PromptComponent from "./main.vue"
//toast提示
const PromptConstrctor = Vue.extend(PromptComponent);
let seed = 1;

const Prompt = function(options){
    let id = 'yd-prompt_' + seed++;

    options.showClose = typeof options.showClose !== 'boolean' ? false : options.showClose;
    
    let instance = new PromptConstrctor({
        data: options
      });
    instance.id = id;
    instance.$mount();
    document.body.appendChild(instance.$el);
    instance.visible = true;
    return new Promise(resolve=>{
      instance.onCallback = resolve;
    })
};
export default Prompt;
